export const validateAuth = (history) => {
    const valid = sessionStorage.getItem('Auth')
    if (valid !== 'True') {
        history.push('/')
    } else {
        console.log('authenticated')
    }
}
